import api from './api';

export interface BulletinRequest {
    studentId: string;
    startDate?: string;
    endDate?: string;
}

export const bulletinService = {
    generateBulletin: async (request: BulletinRequest): Promise<void> => {
        try {
            const response = await api.post('/{schoolId}/bulletins/generate', request, {
                responseType: 'blob', // Important for binary data
            });

            // Create a blob from the response
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Create a link element and trigger download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `bulletin_${request.studentId}.pdf`);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Failed to download bulletin', error);
            throw error;
        }
    },
};
